import {RouteConfig} from 'vue-router';
import Reports from './pages/Reports.vue';
import ReportProvidedWorkTasks from "@/libs/reports/pages/ReportProvidedWorkTasks.vue";
import ReportProvidedWorkTaskByClient from "@/libs/reports/pages/ReportProvidedWorkTaskByClient.vue";
import ReportByCareProviders from "@/libs/reports/pages/ReportByCareProviders.vue";
import ReportActivatedClients from "@/libs/reports/pages/ReportActivatedClients.vue";
import ReportArchivedClients from "@/libs/reports/pages/ReportArchivedClients.vue";
import ReportClients from "@/libs/reports/pages/ReportClients.vue";
import ReportClientsWithCareAllowence from "@/libs/reports/pages/ReportClientsWithCareAllowence.vue";

export default [
    {
        path: '/:tenantId/reports/',
        name: 'Reports',
        component: Reports,
        props: (route) => ({tenantId: route.params.tenantId}),
        meta: {
            permissions: [ "Admin", "Manager" ]
        },
        children: [
            {
                path: 'done-work-tasks',
                name: 'ReportProvidedWorkTasks',
                component: ReportProvidedWorkTasks
            },
            {
                path: 'done-work-task-by-client',
                name: 'ReportProvidedWorkTaskByClient',
                component: ReportProvidedWorkTaskByClient
            },
            {
                path: 'done-work-task-by-care-provider',
                name: 'ReportByCareProviders',
                component: ReportByCareProviders
            },
            {
                path: 'activated-clients',
                name: 'ReportActivatedClients',
                component: ReportActivatedClients
            },
            {
                path: 'archived-clients',
                name: 'ReportArchivedClients',
                component: ReportArchivedClients
            },
            {
                path: 'clients',
                name: 'ReportClients',
                component: ReportClients
            },
            {
                path: 'clients-with-care-allowence',
                name: 'ReportClientsWithCareAllowence',
                component: ReportClientsWithCareAllowence
            }
        ]
    }
] as RouteConfig[];
